// src/app/argent/BandeauArgent.jsx — le bandeau € Argent (totaux du mois).
// CHEMIN ARGENT. Déplacé octet pour octet depuis src/App.jsx (P-3.5, squelette,
// partie 2) : seuls changent l'emballage (signature, retour) et les imports.

import { ARGENT_TABS } from '../onglets'
import { daysInMonth, fmtE } from '../../lib/format'
import { getDegs, isFactureEtat } from '../../lib/incidents-helpers'
import { siLu } from '../../lib/argent-lecture'
// Micro-lot admin (2026-08-01) — marge nette « chiffres partiels » avant le 10
// du mois courant (Synthèse du mois) : condition pure testée, affichage seul.
import { margeNetteEstAttenuee } from '../../lib/synthese-marge-partielle'
import { calcBenefSousLoc, calcChargesFixes } from '../../lib/calc'
import ArgentChrome from '../../views/argent/ArgentChrome'

export function bandeauArgent({
  cfg, argentLectureRatee, incidents, compta, month, tab, setTab, y, m, monthLabel, blocksByMonth,
  dataProjete, calc, navM, isAdmin,
}) {
  return (
    <>
        {/* ══ € ARGENT (lot 5, rangement) — le chrome du proto pour l'ADMIN :
            bandeau « Total à facturer » à chiffres RÉELS + bascule à cinq.
            Les écrans existants se rendent DESSOUS, TELS QUELS (zéro refonte).
            Le ‹ mois › du bandeau pilote navM — les MonthNav des écrans
            rangés sont masqués (doublon d'affichage, aucune logique touchée). */}
        {isAdmin && ARGENT_TABS[tab] && (()=>{
          const propClients = cfg.props.filter(p=>p&&p.id!=="p6")
          const commissions = propClients.reduce((s,p)=>s+(p.logs||[]).reduce((ss,l)=>ss+calc(l.id,l.taux).comm,0),0)
          const sousLoc = calcBenefSousLoc(cfg, month, dataProjete, blocksByMonth)
          const chargesFixes = calcChargesFixes(compta)
          const resultatNet = commissions + sousLoc - chargesFixes
          const totalMen = propClients.reduce((s,p)=>s+(p.logs||[]).reduce((ss,l)=>ss+calc(l.id,l.taux).men,0),0)
          // Total à facturer = même assiette que la Synthèse (commissions +
          // ménage collecté + remplacements d'incidents facturés du mois).
          const totalRemplac = propClients.reduce((s,p)=>s+(p.logs||[]).reduce((ss,l)=>{
            return ss + incidents.reduce((si,inc)=>{
              if(inc.logId!==l.id) return si
              return si + getDegs(inc).filter(d=>isFactureEtat(d)&&d.remplaceLe&&(()=>{const rd=new Date(d.remplaceLe);return rd.getFullYear()===y&&rd.getMonth()+1===m})()).reduce((sd,d)=>sd+(parseFloat(d.cout)||0),0)
            },0)
          },0),0)
          const totalFacture = commissions + totalMen + totalRemplac
          // Résultat net négatif AVANT le 10 du mois courant = chiffres
          // partiels, pas une alerte (helper pur testé) — la mention vit ici
          // depuis le repli du hero Synthèse (décision Dimitri 2026-08-28).
          const margePartielle = margeNetteEstAttenuee(resultatNet, y, m)
          // La commission muette (paquet argent 2026-09-03) : logements dont la
          // commission du mois est incalculable (taux manquant, base > 0) —
          // signalés dans le bandeau, le total s'affichant « — » (incomplet).
          const commissionsManquantes = propClients.flatMap(p=>(p.logs||[])
            .filter(l=>calc(l.id,l.taux).commManquante).map(l=>l.nom))
          const totalNuits = propClients.reduce((s,p)=>s+(p.logs||[]).reduce((ss,l)=>ss+calc(l.id,l.taux).nuits,0),0)
          const totalJours = propClients.reduce((s,p)=>s+(p.logs||[]).reduce((ss,l)=>ss+daysInMonth(y,m),0),0)
          const occupation = totalJours>0?Math.round(totalNuits/totalJours*100):0
          const incidentsMois = incidents.filter(i=>{ const d=new Date(i.createdAt||0); return d.getFullYear()===y&&(d.getMonth()+1)===m })
          return (
            <div className="fbz-tab-content" style={{ paddingBottom: 0 }}>
              <ArgentChrome
                monthLabel={monthLabel}
                nbProprios={propClients.length}
                totalFacture={siLu(argentLectureRatee,totalFacture)}
                commissions={siLu(argentLectureRatee,commissions)}
                sousLoc={siLu(argentLectureRatee,sousLoc)}
                charges={chargesFixes}
                resultatNet={siLu(argentLectureRatee,resultatNet)}
                margePartielle={!argentLectureRatee&&margePartielle}
                menageCollecte={siLu(argentLectureRatee,totalMen)}
                occupation={siLu(argentLectureRatee,occupation)}
                incidents={siLu(argentLectureRatee,incidentsMois.length)}
                commissionsManquantes={commissionsManquantes}
                fmtE={fmtE}
                tabActif={tab}
                onSousOnglet={setTab}
                onMoisPrec={()=>navM(-1)}
                onMoisSuiv={()=>navM(1)}
              />
            </div>
          )
        })()}
    </>
  )
}
